export default {
  ['title']: 'Entry Guide',
  ['label-deadline']: 'Deadline'
}
